// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2sLaN","savePackageButton":"ClientWallet_savePackageButton__1sAP6"};